import { createApp } from 'vue'
import App from './App.vue'
import vue3Spinner from 'vue3-spinner'

createApp(App).use(vue3Spinner).mount('#app')
